import { cloneDeep } from 'lodash-es';
import React, { useEffect, useState } from 'react';

import { IAutomatedBidFloor } from '~/src/dash/api/console-api';
import { FocusedTextfield } from '~/src/dash/components/focused-textfield';
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { Cols } from '~/src/dash/publicaUI';
import { IListItem, IMenuList } from '~/src/dash/types/menuList';
import { publicaColors } from '~/src/dash/utils/colors';

interface IProps {
  rowData: IAutomatedBidFloor;
  channels: IMenuList;
  index: number;
  handleChangeAutomatedBidFloor: (idx: number, field: string, value: any) => void;
  updateSnackbar: (message: string, error: boolean) => void;
}

export const AutomatedBidFloorRow = ({
  rowData,
  channels,
  index,
  handleChangeAutomatedBidFloor,
  updateSnackbar,
}: IProps) => {
  const [selectedSiteID, setSelectedSiteID] = useState<string>(rowData.SiteID || '');
  const [channelList, setChannelList] = useState<IMenuList>(channels);

  useEffect(() => {
    if (selectedSiteID !== '') {
      const clonedChannels = cloneDeep(channels);
      if (clonedChannels[selectedSiteID] !== undefined) {
        clonedChannels[selectedSiteID].selected = true;
        setChannelList(clonedChannels);
      } else {
        updateSnackbar(
          'A channel has been deselected, please choose a new channel to target for Automated Bid Floors',
          true,
        );
        setSelectedSiteID('');
        handleChangeAutomatedBidFloor(index, 'SiteID', '');
      }
    }
  }, []);

  useEffect(() => {
    for (const channel of Object.values(channelList)) {
      if (channel.selected === true) {
        setSelectedSiteID(channel.ID.toString());
        handleChangeAutomatedBidFloor(index, 'SiteID', channel.ID.toString());
        break;
      } else {
        setSelectedSiteID('');
        handleChangeAutomatedBidFloor(index, 'SiteID', '');
      }
    }
  }, [channelList]);

  return (
    <Cols
      marginLeft='16px'
      paddingTop='8px'
      style={{ borderTop: `1px solid ${publicaColors.lightGray}` }}
    >
      <div style={{ width: '220px' }}>
        <MaterialSearchDropdownMulti
          getValueFromSearchElement={(src: IListItem) => src.title}
          selectLimit={1}
          menuTitle='Channel'
          list={channelList}
          onChange={(list: IMenuList) => setChannelList(list)}
          showPrefixID={true}
        />
      </div>
      <div style={{ width: 80, marginLeft: 24 }}>
        <FocusedTextfield
          value={rowData.BaseBidFloor}
          startAdornment='$'
          onChange={(e) =>
            handleChangeAutomatedBidFloor(index, 'BaseBidFloor', e.currentTarget.value)
          }
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flexStart',
            minWidth: '43px',
          }}
        />
      </div>
      <div style={{ width: 80, marginLeft: 48 }}>
        <FocusedTextfield
          value={rowData.MaxBidFloor}
          startAdornment='$'
          onChange={(e) =>
            handleChangeAutomatedBidFloor(index, 'MaxBidFloor', e.currentTarget.value)
          }
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flexStart',
            minWidth: '43px',
          }}
        />
      </div>
      <div style={{ width: 80, marginLeft: 40 }}>
        <FocusedTextfield
          value={rowData.MinBidFloor}
          startAdornment='$'
          minValue={0}
          onChange={(e) =>
            handleChangeAutomatedBidFloor(index, 'MinBidFloor', e.currentTarget.value)
          }
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flexStart',
            minWidth: '43px',
          }}
        />
      </div>
      <div style={{ width: 80, marginLeft: 40 }}>
        <FocusedTextfield
          value={rowData.TestIncrementHigh}
          startAdornment='$'
          onChange={(e) =>
            handleChangeAutomatedBidFloor(index, 'TestIncrementHigh', e.currentTarget.value)
          }
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flexStart',
            minWidth: '43px',
          }}
        />
      </div>
    </Cols>
  );
};
